import { useState } from "react";
import { motion } from "framer-motion";
import { Plus } from "lucide-react";
import { addons } from "@/data";
import { fadeUp, stagger, viewport } from "@/lib/motion";
import EmailCheckoutModal from "@/components/EmailCheckoutModal";

const AddOns = () => {
  const [modalAddon, setModalAddon] = useState(null);
  return (
    <>
    <section className="py-24 md:py-32" data-testid="addons">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-16 items-start">
          <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="lg:sticky lg:top-28">
            <p className="text-[#ccff00] text-xs font-semibold uppercase tracking-widest mb-4">Add-ons</p>
            <h2 className="font-display font-black tracking-tighter text-4xl md:text-5xl leading-tight mb-6">
              Bolt on anything.
            </h2>
            <p className="text-lg text-zinc-400 mb-8">
              Keep it simple, add exactly what you need. Or grab the lot in one irresistible bundle.
            </p>
            <div className="rounded-2xl bg-[#ccff00] text-black p-7" data-testid="launch-everything-bundle">
              <p className="text-xs font-bold uppercase tracking-widest mb-2">🔥 Launch Everything</p>
              <p className="font-display font-black text-5xl mb-3">£799</p>
              <p className="text-sm text-black/80">Website · logo · brand colours · domain · business email · Google setup · social profiles · 10 launch posts · full SEO. Everything, done.</p>
            </div>
          </motion.div>

          <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={viewport} className="grid sm:grid-cols-2 gap-4" data-testid="addons-grid">
            {addons.map((a) => (
              <motion.div
                key={a.name}
                variants={fadeUp}
                whileHover={{ x: 4 }}
                className="flex items-center justify-between rounded-xl bg-[#121212] border border-white/10 px-6 py-5 hover:border-[#ccff00]/40 transition-colors"
                data-testid={`addon-${a.name.toLowerCase().replace(/\s+/g, "-")}`}
              >
                <span className="flex items-center gap-3 text-zinc-200">
                  <Plus size={16} className="text-[#ccff00]" /> {a.name}
                </span>
                {a.lookup ? (
                  <button onClick={() => setModalAddon({ name: a.name, price: a.price, lookup: a.lookup })} className="font-display font-bold text-black bg-[#ccff00] rounded-full px-4 py-1.5 text-sm hover:scale-105 transition-transform flex items-center gap-1.5 min-w-[64px] justify-center" data-testid={`addon-buy-${a.lookup}`}>
                    {a.price}
                  </button>
                ) : (
                  <span className="font-display font-bold text-zinc-400 text-sm">{a.price}</span>
                )}
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
    {modalAddon && <EmailCheckoutModal product={modalAddon} onClose={() => setModalAddon(null)} />}
    </>
  );
};

export default AddOns;
